
/* injects from baggage-loader */

'use strict';

export default class AdminController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

		this.pages = [{
			title: 'Home',
			state: 'admin.home',
			visible: true
		}, {
			title: 'Users',
			state: 'admin.users',
			visible: true
		}]

	}

	$onInit() {

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/admin/admin.controller.js